<groundworks-modal>
  <groundworks-modal-header title="Edit Foreman Bonus" [isCancellable]="true" (cancelModal)="cancel()" />
  <groundworks-modal-body>
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="mb-2">
        <label for="foreman-bonus-percent">Bonus %</label>
        <input id="foreman-bonus-percent" type="number" step="0.01" class="form-control" formControlName="bonusPercent" />
      </div>
      <div class="mb-2">
        <label for="foreman-bonus-amount">Bonus Amount</label>
        <input
          #amountInput
          id="foreman-bonus-amount"
          type="number"
          step="0.01"
          class="form-control"
          formControlName="bonusAmount"
          (blur)="formatAmount()"
        />
      </div>
      <div class="mb-2">
        <label for="foreman-bonus-eligible-date">Date Qualified</label>
        <input id="foreman-bonus-eligible-date" type="date" class="form-control" formControlName="eligibleDate" />
      </div>
      <div class="mb-2">
        <label for="foreman-bonus-notes">Notes</label>
        <textarea id="foreman-bonus-notes" class="form-control" formControlName="notes"></textarea>
      </div>
      @if (errorMessage()) {
        <p class="text-danger" data-testid="foreman-bonus-error">{{ errorMessage() }}</p>
      }
      @if (isApproved()) {
        <p class="text-muted mb-0" data-testid="foreman-bonus-locked-note">
          This bonus is approved and locked. Record another payment to adjust it.
        </p>
      }
    </form>
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
